export const locale = {
  lang: 'pt',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': 'Hoje',
        'TITUNOT': 'Notificações',
        'NOTTTIP': 'Marcar como lido'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': 'A empresa <b>-ALVPRRO-</b> modificou um ou mais de seus e-mails de comunicação',
        'NUEVAMODODS': 'Um gerente de projeto fez alterações em um ou mais emails de comunicação para a empresa <b>-ALVPRRO-</b>'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': 'A empresa <b>-ALVPRRO-</b> enviou para autorizar a pesquisa',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'Certifique',
        '40':'Certifique 3.0',
        '41':'Medida 3.0',
        '42':'Pulsecheck 3.0',
        '43':'Área de foco',
        '56': 'AMCO',
        '57': 'Trabalho Decente',
        '58': 'Primeiro Emprego',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative': 'Você selecionou o idioma principal',
        'sinAdicionales': 'Você não selecionou nenhum idioma adicional',
        'languageAdittional': 'Você selecionou os idiomas adicionais',
        'conAdicionales': 'você não tem nenhum idioma adicional não verificado',
        'deleteLangNative': 'você eliminou a língua nativa',
        'completePasLang': 'Você completou o passo do idioma',
        'completePasTemplate': 'Você completou a etapa do modelo',
        'completePasReacti': 'Você completou a etapa de reagente',
        'completePasNps': 'Você completou a etapa nps',
        'completePasControl': 'Você completou a etapa de controle',
        'completePasDemogra': 'Você completou a etapa demográfica',
        'completePasAbierta': 'Você completou a etapa aberta',
        'completePasAdicio': 'Você completou a etapa adicional',
        'completePas4all': 'Você completou a etapa do forall',
        'completePasEncues': 'Você completou a etapa da pesquisa',
        'completePasColab': 'Você completou a etapa dos colaboradores',
        'completePasEnvi': 'Você completou a etapa de envio',
        'completePasEstat': 'Você completou a etapa de status da pesquisa',
        'completePasProgra': 'Você completou a etapa de programação',
        'DescompletePasLang': 'Você descompletou o passo do idioma',
        'DescompletePasTemplate': 'Você descompletou a etapa do modelo',
        'DescompletePasReacti': 'Você descompletou a etapa reagente',
        'DescompletePasNps': 'Você descompletou a etapa nps',
        'DescompletePasControl': 'Você descompletou a etapa de controle',
        'DescompletePasDemogra': 'Você descompletou a etapa demográfica',
        'DescompletePasAbierta': 'Você não concluiu o passo aberto',
        'DescompletePasAdicio': 'Você não completou a etapa adicional',
        'DescompletePas4all': 'Você descompletou a etapa de forall',
        'DescompletePasEncues': 'Você não concluiu a etapa da pesquisa',
        'DescompletePasColab': 'Você não completou a etapa dos colaboradores',
        'DescompletePasEnvi': 'Você não completou a etapa de envio',
        'DescompletePasEstat': 'Você não completou a etapa de status da pesquisa',
        'DescompletePasProgra': 'Você não completou a etapa de programação',
        'createSurvey': 'Criou-se a createSurvey',
        'saveUserDemo': 'Você salvou os usuários de demonstração para a pesquisa',
        'recreateSurvey': 'A pesquisa foi recriada',
        'saveSeccionNps': 'A seção nps foi salva para a pesquisa',
        'saveSeccionReactivos': 'A seção de reagentes foi salva para a pesquisa',
        'saveSeccionControl': 'A seção de controle foi salva para a pesquisa',
        'saveSeccionDemograficos': 'A seção demográfica foi salva para a pesquisa',
        'saveSeccionAbier': 'A seção aberta foi salva para a pesquisa',
        'saveSeccionForall': 'A seção Forall foi salva na pesquisa',
        'saveSeccionAdicio': 'A seção adicional foi salva para a pesquisa',
        'subBaseColab': 'A base contribuinte foi carregada',
        'DownloadBaseColab': 'A base de colaboradores foi baixada',
        'deleteBaseColab': 'A base contribuinte foi eliminada',
        'saveUsersSurvey': 'Os colaboradores da pesquisa foram salvos',
        'regisFechaLanza': 'A data de lançamento da pesquisa foi registrada',
        'regisFechaAviso1': 'A data do aviso 1 antes da pesquisa foi registrada',
        'regisFechaAviso2': 'A data do aviso 2 antes da pesquisa foi registrada',
        'saveRecordatorioEncu': 'Um lembrete foi gravado',
        'enviarCorreos': 'Você selecionou o envio de correspondência para seus colaboradores',
        'noEnviarCorreos': 'Você selecionou não enviar o correio para seus colaboradores',
        'cambiarEstatusCorreo': 'Você fez a mudança para modificar o envio de correspondência',
        'ActivaEstatEncu': 'A pesquisa foi ativada',
        'DesacEstatEncu': 'A pesquisa foi desativada',
        'activoSeccionNps': 'A seção NPS foi ativada para a pesquisa',
        'desActivoSeccionNps': 'A seção NPS foi desativada para a pesquisa',
        'activoSeccionReactivos': 'A seção REATIVA foi ativada para a pesquisa',
        'desActivoSeccionReactivos': 'A seção REACTIVOS foi desativada para a pesquisa',
        'activoSeccionControl': 'A seção CONTROL foi ativada para a pesquisa',
        'desActivoSeccionControl': 'A seção CONTROL foi desativada para a pesquisa',
        'activoSeccionDemograficos': 'A seção DEMOGRÁFICOS foi ativada para a pesquisa',
        'desActivoSeccionDemograficos': 'A seção DEMOGRÁFICOS foi desativada para a pesquisa',
        'activoSeccionAbiertas': 'A seção OPEN foi ativada para a pesquisa',
        'desActivoSeccionAbiertas': 'A seção ABIERTAS para la encuesta foi desativada',
        'activoSeccionForall':'A seção FORALL foi ativada para a pesquisa',
        'desActivoSeccionForall':'A seção FORALL foi desativada para a pesquisa',
        'activoSeccionAdicionales':'A seção ADICIONAL foi ativada para a pesquisa',
        'desActivoSeccionAdicionales':'A seção ADICIONAL foi desativada para a pesquisa',
        'deletePregTemNps': 'A pergunta foi excluída da seção NPS',
        'deletePregTemReacti': 'A pergunta foi excluída da seção REATIVOS',
        'deletePregTemControl': 'A pergunta foi excluída da seção CONTROL',
        'deletePregTemDemogra': 'A pergunta foi excluída da seção DEMOGRÁFICOS',
        'deletePregTemAbier': 'A pergunta foi excluída da seção OPEN',
        'deletePregTemAdici': 'A pergunta foi excluída da seção ADICIONAL',
        'savePregCatNps': 'A questão do catálogo foi salva na seção NPS',
        'savePregCatReacti': 'A questão do catálogo foi salva na seção REAGENTES',
        'savePregCatControl': 'A questão do catalogador foi salva na seção CONTROL',
        'savePregCatDemogra': 'A questão do catálogo foi salva na seção DEMOGRÁFICOS',
        'savePregCatAbier': 'A questão do catálogo foi salva na seção OPEN',
        'savePregCatAdici':'Salvou a pergunta do catalogador para a seção ADICIONALS',
        'savePregNueNps': 'Nova pergunta foi salva na seção NPS',
        'savePregNueReacti': 'Nova pergunta foi salva na seção REAGENTES',
        'savePregNueControl': 'A nova pergunta foi salva na seção CONTROL',
        'savePregNueDemogra': 'Nova pergunta foi salva na seção DEMOGRÁFICOS',
        'savePregNueAbier': 'Nova pergunta foi salva na seção OPEN',
        'savePregNueAdici': 'Nova pergunta foi salva na seção ADICIONALS',
        'editPregNps': 'A questão foi editada na seção NPS',
        'editPregReacti': 'A seção REAGENTES foi editada',
        'editPregControl': 'A pergunta na seção CONTROL foi editada',
        'editPregDemogra': 'A pergunta na seção DEMOGRÁFICOS foi editada',
        'editPregAbier': 'A pergunta na seção OPEN foi editada',
        'editPregAdici': 'A pergunta na seção ADICIONAL foi editada',
        'LogOut':'Você está logado fora',
        'reiniciarLang':'Você reiniciou o produto',
        'accionText':'',
        'updatCuesForall':'The questionnaire of the forall section has been updated.',
        'savePracticaForall':'A prática para todos foi salva',
        'saveDescripForall':'A descrição da prática para todos foi salva.',

      },
      'BTN_MOSTRAR_HISTO':'Mostrar história',
      'ETI_PRODUC':'Produto:',
      'TITLE_HISTO_PROD':'História do produto',
      'CARG_INFOR': 'Carregamento de informações',
      'TITLE_FILTER': 'Filtro: ',
      'DELETE_FILTER': 'Eliminar filtros',
      'FILTRO_1': 'Data:',
      'BUSCAR_FILTER': 'Busca',
      'TH_TITTLE': 'História do produto',
      'BTN_FILTER_HISTO': 'História do Filtro',
      'TD_USUARIO':'Usuário:',
      'TD_FECHA_PRODU':'Data do produto:',
      'TD_TIPO_PRODU':'Tipo de produto:',
      'TD_TIPO_USU_ADMI': 'Usuário administrador',
      'WARNING_NO_DATOS': 'Nenhuma informação a ser exibida',

    }
  }
};
